import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarCargo = async (cargo) => {
    try {
        if (cargo.id) {
            const resp = await axios.put(
                `${API_URL}/administrar/cargos/${cargo.id}`,
                cargo,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/cargos`,
            cargo,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarCargo = async (id_cargo) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/cargos/${id_cargo}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarCargo = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/cargos/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTipoCargos = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/cargos/select`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};